<template lang="html">

  <section class="modulos-comunicaciones" v-if="recursos.length > 0">

    <h2 class="titulo">{{$t('recursos.titulo')}}</h2>

    <div class="comunicaciones-list row-between" >
      
      <recurso-el v-for="(n,key) in recursos" :data="n" :key="key"></recurso-el>
      
    </div>


  </section>

</template>

<script lang="js">

  import {mapGetters} from 'vuex';

  import recursoEl from './recurso-el'

  export default  {
    name: 'modulo-recursos',
    components :{
      'recurso-el' : recursoEl
    },
    computed : {
      ...mapGetters({
        recursos : 'getRecursos'
      }),
    }
  }
</script>

<style scoped lang="scss">
.titulo{
  width: 100%;
  padding: 10px 20px;
  height: 55px;
  line-height: 18px;
  color: #fff;
  text-align: left;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 16px;
}

.comunicaciones-list{
  padding: 10px;
  max-height: 300px;
  overflow: scroll;
  overflow-x: hidden;
  position: relative;
}


.not-comunicaciones{
  text-align: left;
  font-size: 12px;
}

@media screen and (max-width: 550px){
  .comunicaciones-list{
    padding: 10px
  }
}

</style>



// WEBPACK FOOTER //
// src/components/views/home/modulo-recursos-orientacion.vue